import { ComboCarousel, ComboCarouselNew } from 'components/desktop/organisms';
import { useProductDetailState, useTenantConfig } from 'contexts';
import React from 'react';

export const ProductCombo: React.FC = () => {
  const { epicOmni1286 } = useTenantConfig();
  const { product } = useProductDetailState();

  if (!product?.sku) return null;

  return epicOmni1286 ? (
    <ComboCarouselNew />
  ) : (
    <ComboCarousel mainSku={product?.sku} />
  );
};
